import { useState } from 'react'
import { Props_SnippetTabSwitcher } from './TabSwitcher.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetTabSwitcher = (props: Props_SnippetTabSwitcher) => {
    const { heading, repeatable_tab } = props

    const [activeTab, setActiveTab] = useState(0)

    const snippetID = Math.random().toString(36).substring(2, 10)
    const classHeadingVisibility: string = heading.visibility.value ? `snippet-tab-switcher__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-tab-switcher" id={heading?.snippetid?.value}>
            <div className="snippet-tab-switcher__container">
                <h2 id={`snippet-tab-switcher-${snippetID}`} className={`snippet-tab-switcher__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
                <div className="snippet-tab-switcher__container-wrapper">
                    <div
                        role="tablist"
                        aria-labelledby={`snippet-tab-switcher-${snippetID}`}
                        className={`snippet-tab-switcher__container-tabs`}
                    >
                        {repeatable_tab.map((tab, index) => (
                            <button
                                key={`snippet-tab-switcher-${snippetID}-${index}`}
                                role="tab"
                                aria-selected={activeTab === index}
                                aria-controls={`snippet-tab-switcher-${snippetID}-${index}`}
                                className="snippet-tab-switcher__tabs-button"
                                onClick={() => setActiveTab(index)}
                            >
                                {tab?.heading?.value}
                            </button>
                        ))}
                    </div>
                    <div className="snippet-tab-switcher__container-content">
                        {repeatable_tab.map((tab, index) => (
                            <article
                                key={`snippet-tab-switcher-${snippetID}-${index}`}
                                id={`snippet-tab-switcher-${snippetID}-${index}`}
                                role="tabpanel"
                                aria-hidden={activeTab !== index}
                                className={`snippet-tab-switcher__tab`}
                            >
                                <h3 className="snippet-tab-switcher__tab-heading">{tab.heading?.value}</h3>
                                <div className="snippet-tab-switcher__tab-container">
                                    {tab.image?.value && (
                                        <img
                                            className="snippet-tab-switcher__tab-image"
                                            src={tab.image.value}
                                            alt={tab.alt?.value ? tab.alt.value : ''}
                                            loading="lazy"
                                            height="300"
                                            width="300"
                                        />
                                    )}
                                    <div className="snippet-tab-switcher__tab-container-content">
                                        {tab.content?.value && <div className="snippet-tab-switcher__tab-content">{CompileMarkdown(tab.content.value)}</div>}
                                        {tab.linkText?.value && tab.url?.value && <a href={tab.url.value} className="snippet-tab-switcher__tab-link">{tab.linkText.value}</a>}
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SnippetTabSwitcher